import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { ChargeNumber } from './chargenumber.model';

export const entityName = 'ChargeNumber';

@Injectable()
export class ChargeNumberDataService extends EfaactDataService<ChargeNumber> {
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: ChargeNumber): ChargeNumber {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.CNListID
        };
    }
}
